import axios from "axios";

import {
  debugRequestInterceptor,
  debugResponseInterceptor,
} from "./debugtools.js";
import { expiredTokenInterceptor } from "./expiredToken.js";

const identityInterceptor = () => (a) => a;

export default (baseURL, tokenProvider) => {
  let token = false;
  const updateToken = async () => {
    // TODO: Add a mutex so only one execution of this can be pending at a time
    token = await tokenProvider();
  };

  const buildInstance = () => {
    const fn = (extraConfig = {}) => {
      const http = axios.create({
        baseURL,
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
        ...extraConfig,
      });
      http.interceptors.request.use(debugRequestInterceptor());
      http.interceptors.response.use(debugResponseInterceptor());
      http.interceptors.response.use(
        identityInterceptor(),
        expiredTokenInterceptor(http, tokenProvider)
      );
      return http;
    };
    fn.triggerTokenUpdate = () => updateToken();
    Object.defineProperty(fn, "currentToken", {
      get() {
        return token;
      },
    });
    return fn;
  };

  return buildInstance();
};
